import React from 'react';
import MarkdownPreview from './component/MarkdownPreview';
import './index.css';

const App = () => {
  return (
    <div className="app">
      <MarkdownPreview />
    </div>
  );
};

export default App;